export default __webpack_public_path__ + "static/media/devices_f_500_suspended.e9a007dc.svg";